<template>
    <div class="checkbox-cell">
        <a-checkbox
            :checked="value"
            @change="updateValue"
        />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "CheckboxCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: this.record.data[this.field._id] || false,
        };
    },
    methods: {
        async updateValue(event) {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            const newValue = event.target.checked;
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: newValue,
                });
                this.value = newValue;
            } catch (error) {
                console.error(this.$t("tables.recordUpdatingError"), error);
                this.$message.error(this.$t("tables.recordUpdatingError"));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.checkbox-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    .ant-checkbox-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ant-checkbox {
        transform: scale(1.5);
    }
}
</style>
